<template>
    <CalendarCellTrigger
        :class="
            cn(
                'ds-calendar-cell-trigger h-8 w-8 rounded-full p-0 font-normal',
                // Outside months
                'data-[outside-view]:text-ds-primary-500 data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:bg-ds-primary-100/50 [&[data-outside-view][data-selected]]:text-ds-primary-500 [&[data-outside-view][data-selected]]:opacity-30',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <button
            class="h-8 w-8 rounded-full p-0 font-normal focus:outline-none"
            type="button"
        >
            {{ props.day.day }}
        </button>
    </CalendarCellTrigger>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarCellTriggerProps } from 'reka-ui';
import { CalendarCellTrigger, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<style scoped lang="scss">
@use './styles/ds-calendar-cell-trigger';
</style>
